import { ApiClient } from './apiClient';
import apiConfig from '../configuration/api';

const apiClientInstance = new ApiClient(apiConfig.baseUrl);

export default apiClientInstance;
